// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c8ae65b4","455":"153f29eb","709":"5db02098"}[chunkId] + ".chunk.js";
};